import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default function CursorIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d='m10.083 19.394.057.113a1 1 0 0 0 1.72.007l2.869-4.786 4.785-2.87a1 1 0 0 0-.12-1.777l-14-6c-.83-.356-1.669.483-1.313 1.313l6.002 14zM6.905 6.904l9.903 4.244-3.322 1.995-.102.069a1 1 0 0 0-.242.274l-1.992 3.321-4.245-9.903z' />
    </SvgIcon>
  );
}
